<template>
  <div class="liu" v-wechat-title="'人工审核'">
    <camera ref="camera" @getImgInfo="getImgInfo" />
    <camera2 ref="camera2" @getImgInfo="getImgInfo" />
    <div>
      <div class="color-f-bg">
        <div class="say-color page-padding-l-r padding-t-10 padding-b-10 title-5">
          请拍摄本人的身份证证件
        </div>
        <div class="flex say-color title-5">
          <div class="flex-1 align-center">
            <div @click="$refs.camera.imgClick('renXiang')">
              <img :src="renXiang.base64" class="idCardStyle" v-if="renXiangImgShow" />
              <svg-icon v-else icon-class="authenticate-headshot" class-name="idCardStyle"></svg-icon>
            </div>
            <div class="padding-t-10">人像面</div>
          </div>
          <div class="flex-1 align-center">
            <div @click="$refs.camera.imgClick('guoHui')">
              <img :src="guoHui.base64" class="idCardStyle" v-if="guoHuiImgShow" />
              <svg-icon v-else icon-class="authenticate-emblem" class-name="idCardStyle"></svg-icon>
            </div>
            <div class="padding-t-10">国徽面</div>
          </div>
        </div>
      </div>
      <div class="page-padding-l-r padding-t-10 padding-b-10 margin-t-10 flex color-f-bg">
        <div style="width: 105px">
          <div class="margin-r-10">手持身份证正面照</div>
        </div>
        <div class="flex-1" @click="$refs.camera2.imgClick('shouChi')">
          <img :src="shouChi.base64 || require('@/assets/handheld_example@3x.png')" class="faceStyle" />
        </div>
      </div>
      <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
        避免证件与头部重叠，身份证正反面内容要清晰可见，完全露出双手手臂；上传高分辨率图片可能需要一些时间请耐心等待
      </div>
      <div class="padding-t-10 padding-b-10 page-padding-l-r">
        <mt-button type="primary" size="large"
          :disabled="renXiangImgShow && guoHuiImgShow && shouChiImgShow ? false : true"
          @click="submitData">提交</mt-button>
      </div>
    </div>
  </div>
</template>

<script>
/* global wx */

import camera from '@/components/camera.vue';
import camera2 from '@/components/camera2.vue';
import SvgIcon from '@/components/SvgIcon';
import { SubmitAuditAndUserImage } from '@/api/weChat.js';
import { CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { upLoadImg } from '@/utils/utils.js';
export default {
  name: 'ManualAudit',
  components: { camera, camera2, SvgIcon },
  data() {
    return {
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 手持照片
      shouChi: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 按钮当前的状态
      btnStatus: 1,
      // 身份信息
      formData: {
        idCardName: '',
        idCardNum: '',
      },
      token: '',
      mobile: '',
      product: '',
      renXiangImgShow: false,
      guoHuiImgShow: false,
      shouChiImgShow: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.formData.idCardName = this.$route.query.idCardName;
      this.formData.idCardNum = this.$route.query.idCardNum;
      this.token = this.$route.query.token;
      this.mobile = this.$route.query.mobile;
      this.product = this.$route.query.product;
    });
  },
  methods: {
    // 返回的图片信息
    getImgInfo(info) {
      this[info.type] = info;
      upLoadImg(
        info.blob,
        info.base64,
        info.type,
        this.mobile,
        yes => {
          if (yes.code === 0) {
            if (info.type === 'renXiang') {
              this.renXiangImgShow = true;
              this.renXiang.webUrl = yes.data;
            }
            if (info.type === 'guoHui') {
              this.guoHuiImgShow = true;
              this.guoHui.webUrl = yes.data;
            }
            if (info.type === 'shouChi') {
              this.shouChiImgShow = true;
              this.shouChi.webUrl = yes.data;
            }
          } else {
            this.resetCameraInfo(info.type);
          }
        },
        no => {
          this.resetCameraInfo(info.type);
        }
      );
    },
    // 提交数据
    submitData() {
      CusLoadingOpen();
      SubmitAuditAndUserImage({
        idCardFrontUrl: this.renXiang.webUrl,
        idCardBackUrl: this.guoHui.webUrl,
        holdIdCardUrl: this.shouChi.webUrl,
      })
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            CusAlert('已为您申请人工审核，预计将在1个工作日内完成审核', () => {
              wx.miniProgram.redirectTo({
                url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.formData.idCardName}&flowName=认证流程`,
              });
            });
          } else {
            CusAlert(res.msg);
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },
    // 重新拍照
    resetCameraInfo(name, staus = 1) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      this.btnStatus = staus;
      this.renXiangImgShow = false;
      this.guoHuiImgShow = false;
      this.shouChiImgShow = false;
    },
  },
};
</script>
